import { render, staticRenderFns } from "./qDocument.vue?vue&type=template&id=7f722e02&scoped=true"
import script from "./qDocument.vue?vue&type=script&lang=js"
export * from "./qDocument.vue?vue&type=script&lang=js"
import style0 from "./qDocument.vue?vue&type=style&index=0&id=7f722e02&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f722e02",
  null
  
)

export default component.exports